import { render, staticRenderFns } from "./MeetingQuestionReviewPc.vue?vue&type=template&id=020dfd33&scoped=true"
import script from "./MeetingQuestionReviewPc.vue?vue&type=script&lang=ts"
export * from "./MeetingQuestionReviewPc.vue?vue&type=script&lang=ts"
import style0 from "./MeetingQuestionReviewPc.vue?vue&type=style&index=0&id=020dfd33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020dfd33",
  null
  
)

export default component.exports